import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Icon';
import { BRAND, CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_HREF } from '../site';

export default function Footer() {
  return (
    <footer className="footer dark">
      <div className="wrap footer__grid">
        <div className="footer__brand">
          <a href="#top" className="brand">
            <Logo />
            <span>{BRAND}</span>
          </a>
          <p>
            Voice AI, upselling, kiosks and an admin portal for restaurants that would rather be
            cooking than answering the phone.
          </p>
          <p className="footer__maza">મજા (maza): joy, the good stuff.</p>
        </div>
        <div>
          <h4>Product</h4>
          <a href="#voice-ai">Voice AI ordering</a>
          <a href="#upselling">AI upselling</a>
          <a href="#languages">Languages</a>
          <a href="#kiosk">Self-order kiosk</a>
          <a href="#admin">Admin portal</a>
        </div>
        <div>
          <h4>Company</h4>
          <a href="#demo">Book a demo</a>
          <a href="#faq">FAQ</a>
          <a href={CONTACT_PHONE_HREF}>{CONTACT_PHONE}</a>
          <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
        </div>
        <div>
          <h4>Legal</h4>
          <Link to="/privacy-policy">Privacy policy</Link>
          <Link to="/terms-of-service">Terms of service</Link>
          <Link to="/cookie-policy">Cookie policy</Link>
        </div>
      </div>
      <div className="wrap footer__base">
        <span>
          © {new Date().getFullYear()} {BRAND}. All rights reserved.
        </span>
      </div>
    </footer>
  );
}
